import { useState, useEffect } from 'preact/hooks'

export const noop = () => {}

export function getRandomString(t) {
	const r = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	let n = ''
	for (let a = 0; a < t; a += 1) n += r.charAt(Math.floor(Math.random() * r.length))
	return n
}

export function createLinkAndRedirect(url) {
	if (url) {
		const a = document.createElement('a')
		a.href = url
		a.click()
	}
}
/**
 * Returns 1 by default, or whatever value has been updated to
 */
export function useInputValue(selector) {
	const [value, setValue] = useState(1)
	const el = document.querySelector(selector)

	useEffect(() => {
		if (el) {
			el.addEventListener('input', () => {
				setValue(el.value)
			})
		}
	}, [])

	return value
}

export function createSerializedFormData(form) {
	function serializeForm(formData) {
		const obj = {}

		Array.from(formData.keys()).forEach(key => {
			obj[key] = formData.get(key)
		})

		return obj
	}

	return serializeForm(form)
}

export function createFormDataFromJSON(data) {
	/**
	 * UI will pass "data" as JSON to deserialize/construct into a new FormData object.
	 * So setup some entry array of entries that will be looped later, and a prenulled FormData variable.
	 */
	let formEntries = []
	let formData = null

	try {
		formEntries = JSON.parse(data)
	} catch (ex) {
		/**
		 * No formData was given, just return null here, because any action request
		 * will deal with the case of missing FormData
		 */
		return formData
	} finally {
		if (formEntries.length > 0) {
			/**
			 * Entries were parsed into an array of more than 1 entry, so we
			 * need to set form data in that case.
			 */
			formData = new FormData()
			formEntries.forEach(entry => formData.set(entry.key, entry.value))
		}
	}

	return formData
}

/**
 * Finds and returns a nested object (any level) within an array or object.
 * Usage: findNestedObject(myObj, "keyToFind", wantedValueOfKey);
 * @param {any} The object to search
 * @param {string} The property name to find
 * @param {any} The value to find in the key
 */
export function findNestedObject(entireObj, keyToFind, valToFind) {
	let foundObj

	JSON.stringify(entireObj, (_, nestedValue) => {
		if (nestedValue && nestedValue[keyToFind] === valToFind) {
			foundObj = nestedValue
		}
		return nestedValue
	})

	return foundObj
}

export function keygen(str, i) {
	return `${str}-${getRandomString(i || 2)}`
}

export function getToken() {
	const token = document.getElementsByName('__RequestVerificationToken')[0].value

	if (token) {
		return token
	}
}

export function useProps(props) {
	if (props) {
		try {
			return JSON.parse(props)
		} catch (err) {
			// eslint-disable-next-line no-console
			console.error(`useProps: Couldnt parse JSON from property value given: ${props}`)
		}
	}

	return []
}

export const debounced = (func, wait, immediate) => {
    var timeout

    // need a regular function() {} syntax for the arguments keyword
    // eslint-disable-next-line func-names
    return function () {
        var context = this;
        var args = arguments;
        var call = immediate && !timeout

        var later = function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }

        clearTimeout(timeout)

        timeout = setTimeout(later, wait)

        if (call) func.apply(context, args)
    }
}

/**
 * Execute a function a maximum of 1 time per N (limit) milliseconds
 */
export const throttle = (func, limit) => {
	let inThrottle

	return function () {
		const args = arguments
        const context = this
        
		if (!inThrottle) {
			func.apply(context, args)
			inThrottle = true
			setTimeout(() => (inThrottle = false), limit)
		}
	}
}

export const truncate = (text, length = 80) => {
	if (!text) return ''

	const nextText = text.length > length ? `${text.substring(0, length)}...` : text

	return nextText
}

export const iterable = arr => {
	if (Array.isArray(arr)) {
		if (arr.length > 0) {
			return true
		}

		return false
	}

	return false
}

/**
 * Redirects to given URL and saves the history in the global history object
 */
export const redirect = url => {
	// eslint-disable-next-line no-restricted-globals
	history.pushState({}, document.title, window.location)

	window.location.href = url
}

export const guid = () =>
	'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		const r = (Math.random() * 16) | 0
		const v = c == 'x' ? r : (r & 0x3) | 0x8
		return v.toString(16)
	})

/**
 * Returns random int from a to b
 * @param {number} a From
 * @param {number} b To
 * @returns {number} The generated random number (number)
 */
export const random = (a, b) => Math.floor(Math.random() * b) + a

/**
 * Suffixes a GUID to given URL string
 * @param {string} url - The URL to suffix
 */
export const cachebust = url => {
	const str = guid()

	return `${url}&v=${str}`
}
